module.exports = __webpack_public_path__ + "img/departamento.7bebdf59.svg";